// extracted by mini-css-extract-plugin
export default {"tooltip":"oQ-z","arrow":"pQ-z"};